import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ThemeToggle } from "../ui/ThemeToggle.js";

export function AuthBrand({ brandName = "Altura" }: { brandName?: string }) {
  return (
    <Link to="/" className="focus-ring inline-flex items-center gap-3 rounded-lg">
      <span className="altura-logo-mark flex h-10 w-10 items-center justify-center rounded-[10px] font-display text-lg font-extrabold text-white">{brandName.trim().charAt(0).toUpperCase() || "A"}</span>
      <span className="font-display text-base font-extrabold text-content-primary">{brandName}</span>
    </Link>
  );
}

export function AuthScaffold({
  children,
  eyebrow = "Agent management, made human",
  title = "Move your business forward.",
  detail = "Contracting, visibility, and growth tools in one focused workspace.",
  blankPanel = false,
  brandName = "Altura",
}: {
  children: ReactNode;
  eyebrow?: string;
  title?: string;
  detail?: string;
  /** Keeps the side panel's background and shapes but drops all of its copy. */
  blankPanel?: boolean;
  brandName?: string;
}) {
  return (
    <div className="grid min-h-screen bg-surface-page lg:grid-cols-[minmax(0,1.08fr)_minmax(28rem,.92fr)]">
      <section className="relative flex min-h-screen flex-col px-5 py-5 sm:px-8 sm:py-7 lg:px-12">
        <div className="flex items-center justify-between"><AuthBrand brandName={brandName} /><ThemeToggle /></div>
        <div className="mx-auto flex w-full max-w-lg flex-1 items-center py-10">{children}</div>
        <p className="text-xs text-content-muted">Secure access · {brandName}</p>
      </section>
      <aside
        className="auth-panel relative hidden overflow-hidden border-l border-black/10 p-12 text-white lg:flex lg:flex-col lg:justify-between"
        aria-label={blankPanel ? undefined : `About ${brandName}`}
        aria-hidden={blankPanel || undefined}
      >
        <div className="absolute -right-20 -top-20 h-72 w-72 rounded-full border-[48px] border-[#c8ef63]/80" />
        <div className="absolute -bottom-16 left-12 h-56 w-56 rotate-12 rounded-[12px] bg-[#ff765c]/90" />
        {!blankPanel && (
          <>
            <p className="relative z-10 text-xs font-bold uppercase tracking-[0.17em] text-white/75">{eyebrow}</p>
            <div className="relative z-10 max-w-xl">
              <h2 className="font-display text-6xl font-extrabold leading-[0.96] tracking-[-0.055em]">{title}</h2>
              <p className="mt-6 max-w-md text-lg leading-relaxed text-white/80">{detail}</p>
              <div className="mt-10 grid grid-cols-3 gap-3">
                {["One profile", "Live status", "Real support"].map((item) => <div key={item} className="rounded-[10px] border border-white/25 bg-white/10 p-4 text-sm font-bold backdrop-blur">{item}</div>)}
              </div>
            </div>
            <p className="relative z-10 text-sm font-semibold text-white/70">Built for independent agents and the teams behind them.</p>
          </>
        )}
      </aside>
    </div>
  );
}
